<button type="button" class="btn btn-default" [attr.tabIndex]="tabindex" uib-dropdown-toggle data-disabled="true" data-toggle="dropdown" aria-expanded="false" aria-haspopup="true">
    {{title}} <span class="caret"></span>
</button>

<ul class="dropdown-menu" [ngClass]="{ 'dropdown-menu-right' : openLeft }" role="menu">
    <ng-content></ng-content>
</ul>